import { createFeatureSelector, createSelector } from "@ngrx/store";
import { UserState } from "./user.models";

export const selectUserState = createFeatureSelector<UserState>('user');

export const selectUser = createSelector(
  selectUserState,
  state => state.data
);

export const selectAllUsers = createSelector(
  selectUserState,
  state => state.allData
);

export const selectUserError = createSelector(
  selectUserState,
  state => state.error
);

export const selectUserMessage = createSelector(
  selectUserState,
  state => state.message
);

export const selectUserSuccess = createSelector(
  selectUserState,
  state => state.success
);

export const selectUserValidationErrors = createSelector(
  selectUserState,
  state => state.validationError
);
